import React from 'react';
import { motion } from 'framer-motion';
import { Target, Brain, CalendarCheck, BadgePercent } from 'lucide-react';
const blocks = [{
  icon: Target,
  text: 'Solo organizar tus finanzas no alcanza. Sin enfoque y constancia, es fácil volver al desorden.'
}, {
  icon: Brain,
  text: 'Este pack combina organización financiera + claridad mental + hábitos diarios para sostener el cambio.'
}, {
  icon: CalendarCheck,
  text: 'No solo ves tus números, también sabés qué hacer cada día para mejorar tu situación.'
}, {
  icon: BadgePercent,
  text: 'Por una pequeña diferencia accedés a una herramienta mucho más completa.'
}];
export function WhyPackCompleto() {
  return <section className="py-10 md:py-20 bg-white" data-id="element-245">
      <div className="container mx-auto px-4 md:px-6" data-id="element-246">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-bold text-center text-stone-900 mb-6 md:mb-12" data-id="element-247">
          ¿Por qué elegir el Pack Completo?
        </motion.h2>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" data-id="element-248">
          {blocks.map((block, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-stone-50 rounded-2xl p-4 md:p-6 flex gap-3 md:gap-4 items-start border border-stone-100" data-id="element-249">
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-teal-100 rounded-xl flex items-center justify-center" data-id="element-250">
                <block.icon className="w-5 h-5 md:w-6 md:h-6 text-teal-600" data-id="element-251" />
              </div>
              <p className="text-stone-700 leading-relaxed text-xs md:text-base" data-id="element-252">
                {block.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}